import { Order } from "apps/orders/models/order";
import { SubscriberSimple } from "apps/subscribers/models/subscriber";
import { ActaUser } from "pa_kit/apps/user/models/user";

export class Message {

    constructor(data) {
        this.id = data.id;
        this.subscriber = new SubscriberSimple(data.subscriber_data);
        this.order = new Order(data.order_data);
        this.order_user = data.order_user_data ? new ActaUser(data.order_user_data) : null;
        this.date = data.date;
        this.message = data.message;        
    }
}